var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/file-text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/file-text",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-text",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0296875,6.7640625 L14.9859375,1.7203125 C14.8453125,1.5796875 14.6554687,1.5 14.45625,1.5 L4.5,1.5 C4.08515625,1.5 3.75,1.83515625 3.75,2.25 L3.75,21.75 C3.75,22.1648438 4.08515625,22.5 4.5,22.5 L19.5,22.5 C19.9148437,22.5 20.25,22.1648438 20.25,21.75 L20.25,7.29609375 C20.25,7.096875 20.1703125,6.9046875 20.0296875,6.7640625 Z M18.5203125,7.640625 L14.109375,7.640625 L14.109375,3.2296875 L18.5203125,7.640625 Z M18.5625,20.8125 L5.4375,20.8125 L5.4375,3.1875 L12.515625,3.1875 L12.515625,8.25 C12.515625,8.79375 12.95625,9.234375 13.5,9.234375 L18.5625,9.234375 L18.5625,20.8125 Z M11.8125,14.484375 L7.5,14.484375 C7.396875,14.484375 7.3125,14.56875 7.3125,14.671875 L7.3125,15.796875 C7.3125,15.9 7.396875,15.984375 7.5,15.984375 L11.8125,15.984375 C11.915625,15.984375 12,15.9 12,15.796875 L12,14.671875 C12,14.56875 11.915625,14.484375 11.8125,14.484375 Z M7.3125,11.484375 L7.3125,12.609375 C7.3125,12.7125 7.396875,12.796875 7.5,12.796875 L16.5,12.796875 C16.603125,12.796875 16.6875,12.7125 16.6875,12.609375 L16.6875,11.484375 C16.6875,11.38125 16.603125,11.296875 16.5,11.296875 L7.5,11.296875 C7.396875,11.296875 7.3125,11.38125 7.3125,11.484375 Z",
    id: "Shape",
    fill: "#205527"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/file-text.af7ad8d463558dbcf193b03c32185e27.svg";
export { ForwardRef as ReactComponent };